const colorPaletteEditorType = {
    GRADIENT: 'GRADIENT',
    GRADIENT_MULTI: 'GRADIENT-MULTI',
    COLOR_SINGLE: 'SINGLE-COLOR',
    COLOR_MULTI: 'MULTIPLE-COLOR',
};

export default colorPaletteEditorType;
